var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('patient-profile',{attrs:{"title":"Create Patient Profile","method":"add","changed":_vm.changed},on:{"update:changed":function($event){_vm.changed=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }